import { endsWith, ifElse } from 'ramda';

import isUrl from 'app/router/helpers/isUrl';
import {
  routerLocales,
  unsupportedHelpCenterLocales,
} from 'app/router/constants/routerLocales';
import { CONTACT_US_URL } from 'app/router/constants/externalUrls';

const localeRegex = /^[\w]{2}([-]([\w]{2}))?$/;

const isValidLocale = (locale = '') =>
  localeRegex.test(locale) &&
  Object.values(routerLocales).includes(`/${locale}`);

const localizePath = (path, locale) => {
  if (!path) return path;

  const parts = path.split('/').filter(Boolean);

  if (isValidLocale(parts[0])) {
    parts.shift();
  }
  return [routerLocales[locale], ...parts].join('/') || '/';
};

const localizeUrl = (url, locale) => {
  if (
    endsWith(CONTACT_US_URL, url) &&
    unsupportedHelpCenterLocales.includes(locale)
  )
    return url;
  const localizedUrl = document.createElement('a');

  localizedUrl.href = url;
  localizedUrl.pathname = localizePath(localizedUrl.pathname, locale);
  return localizedUrl.href;
};

const localizeLink = ifElse(isUrl, localizeUrl, localizePath);

export default localizeLink;
